import { doRequest } from '../../api/index';
import store from '../index';

const state = {
  events: {},
  groups: {},
  participants: {},
  eventDetail: {},
  participantDetail: {},
  volunteerTypes: [],
  users: {},
  usersDetail: {}
};

const getters = {
  getVolunteerTypes(s) {
    return s.volunteerTypes;
  },
  getVolunteerTypesOptions(s) {
    return s.volunteerTypes ? s.volunteerTypes.map((type) => {
      return {
        label: type.name,
        value: type.id
      };
    }) : [];
  },
  getGroups: (s) => (eventId) => {
    return s.groups[eventId] ?
      s.groups[eventId].map((group) => {
        return {
          label: group.group_name,
          value: group.group_name
        }
      }) : [];
  },
  getGroupsList: (s) => (eventId) => {
    return s.groups[eventId] ?
      s.groups[eventId] : [];
  }
};

const actions = {
  loadUsers({ commit }, args) {
    return doRequest('user.list', args)
      .then((data) => {
        commit('setUsers', {
          ...data,
          page: data.current_page
        });
      });
  },
  loadEvents({ commit }, args) {
    return doRequest('events.list', args)
      .then((data = {}) => {
        commit('setEvents', {
          ...data,
          page: data.current_page
        });
      });
  },
  loadGroups({commit}, args) {
     return doRequest('events.groups', args)
      .then((data = {}) => {
        commit('setEventGroups', {
          data,
          eventId: args.eventId
        });
      });
  },
  generateGroups({commit}, args) {
    return doRequest('events.generateGroups', args);
  },
  loadVolunteerTypes({ commit }, args) {
    if (store.state.admin.volunteerTypes.length === 0) {
      return doRequest('volunteers.typeList', args)
        .then((data) => {
          commit('setVolunteerTypes', data);
        });
    }

    return Promise.resolve();
  },
  loadParticipants({ commit }, args) {
    return doRequest('participants.list', args)
      .then((data) => {
        commit('setParticipants', {
          ...data,
          eventId: args.eventId,
          page: args.page,
        });
      });
  },
  loadParticipantDetail({ commit }, args) {
    return doRequest('participants.detail', args)
      .then((data) => {
        commit('setParticipant', {
          data,
          eventId: args.eventId,
          userId: args.userId,
        });
      });
  },
  editParticipant({ commit }, args) {
    return doRequest('participants.edit', args);
  },
  unsubscribeParticipant({commit}, args) {
    return doRequest('participants.unsubscribe', args);
  },
  subscribeParticipant({commit}, args) {
    return doRequest('participants.subscribe', args);
  },
  createEvent({ commit }, args) {
    return doRequest('events.create', args);
  },
  editEvent({ commit }, args) {
    return doRequest('events.edit', args);
  },
  detailEvent({ commit }, args) {
    return doRequest('events.detail', args)
      .then((data) => {
        commit('setEventDetail', {
          eventId: args.eventId,
          data: data ? data.data : {}
        });
      });
  },
  deleteEvent({ commit }, args) {
    return doRequest('events.delete', args);
  },
  uploadPaymentLog({ commit }, args) {
    return doRequest('events.uploadPaymentLog', args);
  },
  editUser({ commit }, args) {
    return doRequest('user.editUser', args).then(() => {
      commit('clearUsers');
    });
  },
  userDetail({ commit }, args) {
    return doRequest('user.userDetail', args)
      .then((data) => {
        commit('setUserDetail', {
          data: data,
          userId: args.userId
        });
      });
  },
  resetUserPassword({ commit }, args) {
    return doRequest('user.resetPassword', args);
  }
};

const mutations = {
  setEvents(s, data) {
    s.events = Object.assign({}, s.events, {
      [data.page]: data
    });
  },
  setEventGroups(s, data) {
    s.groups[data.eventId] = data.data;
  },
  setUsers(s, data) {
    s.users = Object.assign({}, s.users, {
      [data.page]: data
    });
  },
  setUserDetail(s, data) {
    s.usersDetail = Object.assign({}, s.usersDetail, {
      [data.userId]: data.data
    });
  },
  setParticipant(s, data) {
    s.participantDetail = Object.assign({}, s.participantDetail, {
      [data.eventId]: {
        [data.userId]: data.data
      }
    });
  },
  setEventDetail(s, data) {
    s.eventDetail = Object.assign({}, s.eventDetail, {
      [data.eventId]: data.data
    });
  },
  setVolunteerTypes(s, data) {
    s.volunteerTypes = data;
  },
  setParticipants(s, data) {
    s.participants = Object.assign({}, s.participants, {
      [data.eventId]: {
        [data.page]: data
      }
    });
  },
  clearEvents(s) {
    s.events = {};
  },
  clearUsers(s) {
    s.users = {};
  },
  clearParticipants(s) {
    s.participants = {};
  }
};


export default {
  state,
  getters,
  actions,
  mutations,
};
